var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlassSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0095DF",
    fillRule: "evenodd",
    d: "M11.43 20.273H5.07A2 2 0 0 1 3.097 18.6L.194 1.164A1 1 0 0 1 1.18 0h14.14a1 1 0 0 1 .986 1.164l-2.903 17.437a2 2 0 0 1-1.973 1.672z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlassSmall);
export default __webpack_public_path__ + "static/media/glass_small.ac1e76868cbeaf90734e54a5c03ffd2b.svg";
export { ForwardRef as ReactComponent };